import * as React from "react";
import { Container } from "@mui/material";
import Header from "./Header/header";
import Footer from "./Footer";

import useStyles from "./css";

export default function Layout(props: any) {
  const classes = useStyles();

  return (<>
    <Container component="main" className={classes.printWrapper} > 
    
        <Header />

        <Container className={classes.content} >
          {props.children}
        </Container>
      
        <Footer />
        
    </Container>
  </>);
}
